// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__118Ta","rootCenter":"LoadMoreObserver_rootCenter__3aqxh","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3x6Vv"};